import React, { useEffect } from "react";
import "./Notification.css";
import Topbar from "../Topbar/Topbar";
import { Row, Col, Container } from "react-bootstrap";
import { IoIosWarning } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { FaCircleStop } from "react-icons/fa6";
import { RiErrorWarningFill } from "react-icons/ri";
import Swal from "sweetalert2";


import { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

export default function Notification() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [expanded, setExpanded] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const staffid = useSelector((state) => state.id);
  console.log(staffid);
  //handle delete notification
 const handleDelete = async (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "you want to delete this notifications permanently?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        await axios.delete(`${apiUrl}notify/${id}`);
        setNotifications((prev) => prev.filter((n) => n._id !== id));

        Swal.fire("Deleted!", "The notification has been deleted.", "success");
      } catch (err) {
        console.error("Delete failed", err);
        Swal.fire("Error", "Failed to delete notification", "error");
      }
    }
  });
};

// Delete all notifications
const handleDeleteAll = async () => {
  Swal.fire({
    title: "Are you sure?",
    text: "you want to delete all notifications permanently?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, clear all!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        await axios.delete(`${apiUrl}notify/clear/${staffid}`);
        setNotifications([]); // instantly clear UI

        Swal.fire("Cleared!", "All notifications have been cleared.", "success");
      } catch (err) {
        console.error("Failed to clear notifications", err);
        Swal.fire("Error", "Failed to clear notifications", "error");
      }
    }
  });
};
  // Function to format date and time
  const formatDateTime = (isoString) => {
    const dateObj = new Date(isoString);
    const optionsDate = {
      day: "2-digit",
      month: "short",
      timeZone: "Asia/Kolkata",
    };
    const optionsTime = {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    };

    const formattedDate = dateObj.toLocaleDateString("en-US", optionsDate); // e.g., 31-Jul
    const formattedTime = dateObj.toLocaleTimeString("en-US", optionsTime); // e.g., 6:12 PM

    return { formattedDate, formattedTime };
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = await axios.get(`${apiUrl}notify/${staffid}`);
        if (res.data.success) {
          setNotifications(res.data.data);
        } else {
          console.error("Failed to fetch notifications");
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    if (staffid) {
      fetchNotifications();
    }
  }, [staffid]);
  return (
  <div>
    <Topbar />
    <Container>
      <Row>
        <Col className="text-start">
        <h2 className="mt-4 notify-title">Notifications</h2>
        </Col>
      <Col className="text-end">
      <button onClick={() => handleDeleteAll()} className="black-btn mt-4 ">Delete All</button>
      </Col>
      </Row>
      <div className="notification-container mt-3">
        {notifications.length > 0 ? (
          notifications.map((notification, index) => {
            const { formattedDate, formattedTime } = formatDateTime(notification.createdAt);

            return (
              <div className="notification-box" key={index}>
                <Row className="align-items-center">
                  <Col xs={2} sm={1} className="text-center">
                    <IoIosWarning size={24} style={{ color: "#ffcc00" }} />
                  </Col>
                  <Col xs={10} sm={7}>
                    <h6 className="mb-1">{notification.title}</h6>
                    <p className="mb-0">{notification.body}</p>
                  </Col>
                  <Col xs={6} sm={2} className="text-sm-end text-muted small">
                    <p className="mb-0">{formattedDate}</p>
                    <p className="mb-0">{formattedTime}</p>
                  </Col>
                  <Col xs={6} sm={2} className="text-end">
                    <MdDelete
                      size={20}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDelete(notification._id)}
                    />
                  </Col>
                </Row>
              </div>
            );
          })
        ) : (
          <p className="text-center mt-3">No notifications found.</p>
        )}
      </div>
    </Container>
  </div>
);


  // return (
  //   <div>
  //     <Topbar />
  //     <Container>
  //       <h2>Notification</h2>

  //       {/* <div className="notification-container mt-3">
  //         <Row className="pt-3 px-4">
  //           <Col md={1} sm={1}>
  //             <IoIosWarning
  //               size={30}
  //               style={{ color: "yellow", fontSize: "20px" }}
  //             />
  //           </Col>
  //           <Col md={8} sm={8}>
  //             <h6>Warnign</h6>
  //             <p>
  //               Your password is not{" "}
  //               <span className="text-primary">read more</span>{" "}
  //             </p>
  //           </Col>
  //           <Col md={2} sm={2}>
  //             <p>29-Oct</p>
  //             <p>12:12 pm</p>
  //           </Col>
  //           <Col md={1} sm={1}>
  //             <MdDelete size={25} />
  //           </Col>
  //         </Row>
  //       </div> */}

  //       <div className="notification-container mt-3">
  //         {notifications.length > 0 ? (
  //           notifications.map((notification, index) => {
  //             const { formattedDate, formattedTime } = formatDateTime(
  //               notification.createdAt
  //             );

  //             return (
  //               <Row
  //                 className="pt-3 px-4"
  //                 key={index}
  //                 style={{ borderBottom: "1px solid #ddd" }}
  //               >
  //                 <Col md={1} sm={1}>
  //                   <IoIosWarning
  //                     size={30}
  //                     style={{ color: "yellow", fontSize: "20px" }}
  //                   />
  //                 </Col>
  //                 <Col md={8} sm={8}>
  //                   <h6>{notification.title}</h6>
  //                   <p>{notification.body}</p>
  //                 </Col>
  //                 <Col md={2} sm={2}>
  //                   <p>{formattedDate}</p>
  //                   <p>{formattedTime}</p>
  //                 </Col>
  //                 <Col md={1} sm={1}>
  //                   <MdDelete
  //                     size={25}
  //                     style={{ cursor: "pointer" }}
  //                     onClick={() => handleDelete(notification._id)}
  //                   />
  //                 </Col>
  //               </Row>
  //             );
  //           })
  //         ) : (
  //           <p className="text-center mt-3">No notifications found.</p>
  //         )}

  //         {/* <Row className="pt-3 px-4">
  //           <Col md={1} sm={1}>
  //             <FaCircleStop
  //               size={30}
  //               style={{ color: "red", fontSize: "20px" }}
  //             />
  //           </Col>

  //           <Col md={8} sm={8}>
  //             <h6>Warnign</h6>
  //             <p>
  //               Your password is not{" "}
  //               <span className="text-primary">read more</span>{" "}
  //             </p>
  //           </Col>
  //           <Col md={2} sm={2}>
  //             <p>29-Oct</p>
  //             <p>12:12 pm</p>
  //           </Col>
  //           <Col md={1} sm={1}>
  //             <MdDelete size={25} />
  //           </Col>
  //         </Row> */}
  //       </div>

  //       {/* <div className="notification-container mt-3">
  //         <Row className="pt-3 px-4">
  //           <Col md={1} sm={1}>
  //             <RiErrorWarningFill
  //               size={30}
  //               style={{ color: "blue", fontSize: "20px" }}
  //             />
  //           </Col>
  //           <Col md={8} sm={8}>
  //             <h6>Warnign</h6>
  //             <p>
  //               Your password is not{" "}
  //               <span className="text-primary">read more</span>{" "}
  //             </p>
  //           </Col>
  //           <Col md={2} sm={2}>
  //             <p>29-Oct</p>
  //             <p>12:12 pm</p>
  //           </Col>
  //           <Col md={1} sm={1}>
  //             <MdDelete size={25} />
  //           </Col>
  //         </Row>
  //       </div> */}
  //     </Container>
  //   </div>
  // );
}
